import React, { Component, Fragment } from 'react';
import history from 'dashboard/history';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import Icon from 'components/Icon/Icon.react';
import stylesButton from 'components/Button/Button.scss';
import LogView from 'components/LogView/LogView.react';
import LogViewEntry from 'components/LogView/LogViewEntry.react';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator.react';
import SashiDoParse from '../SashiDoParse';
import styles from './EngineView.scss';

const { SASHIDO_API_URL, SASHIDO_API_ID, SASHIDO_API_JS_KEY } = process.env;
const BuildLogStream = SashiDoParse.Object.extend('BuildLogStream');

const STATUS_COLOR = {
  new: 'orange',
  pending: 'blue',
  running: 'blue',
  failed: 'red',
  cancelled: 'gray',
  complete: 'green',
  active: 'green',
};

const STATUS_CONTENT = {
  new: 'NEW',
  pending: 'PENDING',
  running: 'RUNNING',
  failed: 'FAILED',
  cancelled: 'CANCELLED',
  complete: 'COMPLETE',
  active: 'ACTIVE',
};

export default class RealTimeLogView extends Component {
  constructor() {
    super();
    this.section = 'Runtime';
    this.subsection = 'Builds';

    this.state = {
      logs: [],
    };
  }

  componentDidMount() {
    this.runLiveQuery();
  }

  componentWillReceiveProps(NextProps) {
    if (NextProps.buildId !== this.props.buildId) {
      if (this.subscription) {
        this.subscription.unsubscribe();
        this.subscription = null;
      }

      this.setState({
        logs: [],
      }, () => {
        this.runLiveQuery();
      });
    }
  }

  componentWillUnmount() {
    if (this.client) {
      this.client.close();
      this.client = null;
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  runLiveQuery() {
    const { buildId } = this.props;

    if (!buildId) {
      return null;
    }

    const userObject = JSON.parse(window.localStorage.getItem(`SashiDo/${SASHIDO_API_ID}/currentUser`));
    const sessionToken = userObject ? userObject.sessionToken : '';
    this.client = new SashiDoParse.LiveQueryClient({
      applicationId: SASHIDO_API_ID,
      serverURL: SASHIDO_API_URL.replace('https', 'wss'),
      javascriptKey: SASHIDO_API_JS_KEY,
    });

    this.client.open();

    const query = new SashiDoParse.Query(BuildLogStream);
    query.equalTo('build', { __type: 'Pointer', className: 'Build', objectId: buildId });
    this.subscription = this.client.subscribe(query, sessionToken);


    this.subscription.on('create', (obj) => {
      this.setState((prevState) => {
        return {
          logs: [...prevState.logs, { objectId: obj.id, ...obj.attributes }],
        };
      });
    });

    return null;
  }

  render() {
    const { buildId } = this.props;

    if (!buildId) {
      return null;
    }

    const { logs } = this.state;
    const { LatestCreatedBuild } = this.props.liveQueries;

    let phase = 'New';

    if (logs && logs.length > 0) {
      const { build } = logs[logs.length - 1];
      phase = (build.phase || build.attributes.phase);
    }

    const color = STATUS_COLOR[(phase || '').toLowerCase()];
    const status = STATUS_CONTENT[(phase || '').toLowerCase()];

    return (
      <div className={styles.newBuild}>
        <div className={styles.header}>
          {
            LatestCreatedBuild.number
              ? <span>Build #{LatestCreatedBuild.number}</span>
              : <LoaderDots />
          }

          {
            ((phase !== 'Complete' && phase !== 'Failed') && LatestCreatedBuild.number) &&
              <span
                className={[stylesButton.tableButton, stylesButton.red].join(' ')}
                onClick={() => this.props.cancelHandler(LatestCreatedBuild.name)} >
                Cancel
              </span>
          }

          {
            (phase === 'Complete' || phase === 'Failed') &&
              <span
                className={[stylesButton.tableButton, stylesButton.red].join(' ')}
                onClick={() => this.props.closeHandler()} >
                x
              </span>
          }
        </div>


        <div className={styles.realtimeLogHolder}>
          {
            logs.length > 0
              ?
                <span
                  className={styles.fullScreen}
                  onClick={() => history.push(`/products/apps/${this.props.slug}/runtime/builds/${buildId}/log`)}>
                  <Icon name="icon-fullscreen" width={14} height={14} />
                </span>
              : null
          }
          <LogView autoscroll>
            <Fragment>
              {
                logs.map(({ objectId, text }) => {
                  let rowText = text;
                  if (rowText.includes('Pulling image')) {
                    rowText = 'Pulling image';
                  }
                  if (rowText.includes('Pushing image')) {
                    rowText = 'Pushing image';
                  }

                  return (
                    <LogViewEntry
                      key={`log-entry-${objectId}`}
                      text={rowText}
                      enableDate={false}
                      customClass="buildLogs" />
                  );
                })
              }

              {
                logs.length > 0
                  ?
                    <LogViewEntry
                      text=" "
                      enableDate={false}
                      customClass="buildLogs" />
                  : null
              }

              {
                phase !== 'Complete'
                  ?
                    <div className={styles.lll}>
                      <StatusIndicator color={color} status={status} loading />
                    </div>
                  :
                    <div className={styles.lll}>
                      <StatusIndicator color={color} status={status} />
                    </div>
              }

            </Fragment>
          </LogView>
        </div>
      </div>
    );
  }
}
